var _circle, _rect, _rect2, _rect3, _path, _rect4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAuthSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 100,
    r: 100,
    fill: "#F3F6FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 39,
    width: 64,
    height: 121,
    rx: 6,
    fill: "white",
    stroke: "#407EDB",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 45,
    width: 16,
    height: 4,
    rx: 2,
    fill: "#666E7A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 154,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#666E7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.56 106.179V94.5498H124.189L112.56 106.179Z",
    fill: "#275CAB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 58,
    width: 60.9163,
    height: 37.6574,
    rx: 4,
    fill: "#407EDB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.944,
    cy: 77.1054,
    r: 3.04582,
    fill: "#275CAB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.235,
    cy: 77.1054,
    r: 3.04582,
    fill: "#275CAB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.526,
    cy: 77.1054,
    r: 3.04582,
    fill: "#275CAB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.837,
    cy: 76.5517,
    r: 3.04582,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.128,
    cy: 76.5517,
    r: 3.04582,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.419,
    cy: 76.5517,
    r: 3.04582,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthSms);
export default __webpack_public_path__ + "static/media/icon_auth_sms.851eccf614e09da2a2057a49e6fbe004.svg";
export { ForwardRef as ReactComponent };